export const FILE_UPLOAD_START = 'FILE_UPLOAD_START' as const;
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS' as const;
export const FILE_UPLOAD_FAILURE = 'FILE_UPLOAD_FAILURE' as const;
export const FETCH_DATA_START = 'FETCH_DATA_START' as const;
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS' as const;
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE' as const;
export const DELETE_MEDICAL_RECORD_START = 'DELETE_MEDICAL_RECORD_START' as const;
export const DELETE_MEDICAL_RECORD_SUCCESS = 'DELETE_MEDICAL_RECORD_SUCCESS' as const;
export const DELETE_MEDICAL_RECORD_FAILURE = 'DELETE_MEDICAL_RECORD_FAILURE' as const;
export const DOWNLOAD_MEDICAL_RECORD_START = 'DOWNLOAD_MEDICAL_RECORD_START' as const;
export const DOWNLOAD_MEDICAL_RECORD_SUCCESS = 'DOWNLOAD_MEDICAL_RECORD_SUCCESS' as const;
export const DOWNLOAD_MEDICAL_RECORD_FAILURE = 'DOWNLOAD_MEDICAL_RECORD_FAILURE' as const;
